import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  inject,
  isDevMode,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { API_BASE_URL, IDENTITY_CONFIG, LibUiModule } from '@lib-ui';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IndexedDbModule } from '@zapp/indexedDb.module';
import { MsalModule, MsalService } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { CoreModule } from '@portal/core/core.module';
import { APP_ROUTES } from '@portal/app.routes';
import { GetProtectedResourcesMap, getPublicClientApplication } from '../auth-config';
import { environment } from '../environments/environment';
import { StartupService } from '@portal/core/services';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom([
      LibUiModule.forRoot(environment),
      CoreModule,
      BrowserAnimationsModule,
      IndexedDbModule,
      MatNativeDateModule,
      MsalModule.forRoot(
        getPublicClientApplication(),
        {
          // The routing guard configuration.
          interactionType: InteractionType.Redirect,
          authRequest: { scopes: [environment.AadScope] },
          // important for the cancelation of "reset password"
          loginFailedRoute: '/login-failed',
        },
        {
          // MSAL interceptor configuration.
          // The protected resource mapping maps your web API with the corresponding app scopes. If your code needs to call another web API, add the URI mapping here.
          interactionType: InteractionType.Redirect,
          protectedResourceMap: GetProtectedResourcesMap(),
        },
      ),
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isDevMode(),
        // Register the ServiceWorker as soon as the application is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: 'registerWhenStable:30000',
      }),
    ]),
    provideAppInitializer(() => inject(StartupService).load()),
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
    {
      provide: API_BASE_URL,
      useFactory: () => environment.apiBaseUrl,
    },
    {
      provide: IDENTITY_CONFIG,
      useValue: {
        releaseNotes: 'assets/release-notes.ts',
        logoPath: 'assets/portal-logo.svg',
        urlsNotToNavigateToUnauthorizeUrl: ['/api/User/generatePasswordResetToken'],
      },
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (msalService: MsalService) => () => {
        return msalService.handleRedirectObservable();
      },
      deps: [MsalService],
      multi: true,
    },
  ],
};
